﻿import { useState, useEffect, useMemo } from 'react';

export default function useSortData(initialData, defaultSortConfig = { key: null, direction: 'ascending' }) {
    const [data, setData] = useState(initialData);
    const [sortConfig, setSortConfig] = useState(defaultSortConfig);

    useEffect(() => {
        setData(initialData);
    }, [initialData])

    const sortBy = (key) => {
        let direction = 'ascending';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending')
            direction = 'descending';
        setSortConfig({ key, direction });
    }

    const sortedData = useMemo(() => {
        if (data === null) return data;
        let sortableData = [...data];
        if (sortConfig !== null) {
            sortableData = [...data].sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key])
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                if (a[sortConfig.key] > b[sortConfig.key])
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                return 0;
            });
        }
        return sortableData;
    }, [data, sortConfig]);

    return { sortedData, sortBy, sortConfig };
}